import type { ReactNode } from "react";
import { StyledTooltipButtonLink, StyledTooltipButtonLinkText } from "./styles";

type Props = {
    text: NonNullable<ReactNode>;
    redirectLink: URL["href"];
    withPointerEvents?: boolean;
    onClick?(): void;
};

const SignalsTooltipButtonLink = ({ text, redirectLink, withPointerEvents = true, onClick }: Props) => {
    const shouldHandlePointerEvents = withPointerEvents && typeof onClick === "function";

    const handleClick = () => {
        if (!shouldHandlePointerEvents) {return;}

        onClick?.();
    };

    return (
        <StyledTooltipButtonLink
            target="_blank"
            href={redirectLink}
            isDisabled={!shouldHandlePointerEvents}
            withIcon
            onClick={handleClick}
        >
            <StyledTooltipButtonLinkText>{text}</StyledTooltipButtonLinkText>
        </StyledTooltipButtonLink>
    );
};

export default SignalsTooltipButtonLink;
